import {  UsingObservable  } from './UsingObservable';

export const using = UsingObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/using.ts